export enum ModuleTypeEnum {
  SALES = 1,
  CRM = 2,
  MARKETING = 3
}
